export default __webpack_public_path__ + "static/media/ic-transmgt.36c1d45e.svg";